type TSelectItemProps = {
  value: number;
  label: string;
  handleClick: () => void;
};

export const SelectItem = ({ value, label, handleClick }: TSelectItemProps) => (
  <div
    key={value}
    className="py-[14px] px-4 rounded hover:bg-gray-500 focus:bg-gray-500 text-md cursor-pointer"
    onClick={handleClick}
  >
    {label}
  </div>
);
